import JourneyForm from "./form"

export default JourneyForm
